/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import {
	useCollectionsIntroductionDismissed,
	useCollectionsIntroductionPrerequisiteDismissalsMet,
} from '../../../../controllers/selectors/collections-hooks.tsx';
import { useProductUsageStartTimestamp } from '../../../../controllers/selectors/product-usage-start-timestamp-hooks.tsx';
import { checkIfOlderThanNDays } from '../../../../utils/checkIfOlderThanNDays.tsx';
import { useHasAtLeastTwoJpdSpaces } from './useHasAtLeastTwoJpdSpaces.tsx';

export const useIsLicensedUser = (): boolean => {
	const { hasProductDiscoveryAccess } = useApplicationPermissions() ?? {};
	return Boolean(hasProductDiscoveryAccess);
};

/**
 * Hook to determine if the roadmap introduction spotlight should be shown
 * This hook was implemented based on RoadmapIntroductionSpotlight logic
 * src/packages/polaris/app-ideas/src/ui/create-issue-interceptor/index.tsx
 * This hook checks:
 * - User licensing status
 * - Whether already on roadmaps page
 * - Dismissal state
 * - Prerequisites met
 * - User age requirements
 */
export const useShouldShowRoadmapsIntroductionSpotlight = (): boolean => {
	const isLicensedUser = useIsLicensedUser();
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const isAlreadyInRoadmaps = window?.location.href.includes('roadmap');

	const isIntroductionDismissed = useCollectionsIntroductionDismissed();
	const arePrerequisiteDismissalsMet = useCollectionsIntroductionPrerequisiteDismissalsMet();
	const productUsageStartTimestamp = useProductUsageStartTimestamp();

	const hasAtLeastTwoSpaces = useHasAtLeastTwoJpdSpaces();

	// Determine if should show the spotlight
	return !(
		isAlreadyInRoadmaps ||
		!isLicensedUser ||
		!hasAtLeastTwoSpaces ||
		isIntroductionDismissed === undefined ||
		isIntroductionDismissed ||
		!arePrerequisiteDismissalsMet ||
		!checkIfOlderThanNDays(productUsageStartTimestamp)
	);
};
